import classNames from "classnames";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Link from "@Components/atoms/Link";
import "./style.scss";

interface Props {
  isUserGuest: boolean;
  onClick: () => void;
}

const HeaderMobileCart: FunctionComponent<Props> = ({ isUserGuest, onClick }) => {
  const intl = useIntl();

  return (
    <div className="HeaderMobileCart">
      <Link href={`/${intl.locale}/`}>{intl.formatMessage({ id: "cheerz_Header_home" })}</Link>
      <div className="HeaderMobileCart-center">
        {intl.formatMessage({ id: "cheerz_HeaderMobileCart_title" })}
      </div>
      <div
        className={classNames("HeaderMobileCart-right", {
          "HeaderMobileCart-right--hidden": !isUserGuest,
        })}
      >
        <Link onClick={onClick}>{intl.formatMessage({ id: "cheerz_Header_login" })}</Link>
      </div>
    </div>
  );
};

export default HeaderMobileCart;
